export const GLOSSARY = [
  {
    "key": 1,
    "value": "Academic benchmarks",
    "description": "Standardized tests used to evaluate model performance across different tasks and capabilities."
  },
  {
    "key": 2,
    "value": "Access controls",
    "description": "Security measures that regulate who can access specific resources or data in AI systems."
  },
  {
    "key": 3,
    "value": "Accuracy",
    "description": "Metric indicating the proportion of correct predictions made by a model."
  },
  {
    "key": 4,
    "value": "Action groups",
    "description": "Defined sets of tasks and parameters that agents can perform within Amazon Bedrock."
  },
  {
    "key": 5,
    "value": "Activation functions",
    "description": "Mathematical functions applied to neuron outputs in neural networks to introduce non-linearity."
  },
  {
    "key": 6,
    "value": "Administrative safeguards",
    "description": "Management policies and procedures designed to protect electronic protected health information."
  },
  {
    "key": 7,
    "value": "Adversarial attacks",
    "description": "Techniques used to manipulate AI systems into producing incorrect or undesired outputs."
  },
  {
    "key": 8,
    "value": "Adversarial data crafting",
    "description": "Process of modifying input data to deceive ML models into producing incorrect outputs."
  },
  {
    "key": 9,
    "value": "Adversarial robustness toolbox",
    "description": "Open-source library originally designed for research that can be used to create adversarial attacks against AI systems."
  },
  {
    "key": 10,
    "value": "Adversarial techniques",
    "description": "Methods used to exploit vulnerabilities in AI systems for malicious purposes."
  },
  {
    "key": 11,
    "value": "Agentic workflows",
    "description": "Systems where AI agents break down complex tasks into sequential steps with clear handoffs between components."
  },
  {
    "key": 12,
    "value": "Agents",
    "description": "AI systems that can execute complex tasks by interacting with various systems and APIs."
  },
  {
    "key": 13,
    "value": "AI",
    "description": "See artificial intelligence."
  },
  {
    "key": 14,
    "value": "AI governance",
    "description": "Framework of policies and procedures ensuring ethical and compliant AI system operation."
  },
  {
    "key": 15,
    "value": "AI security",
    "description": "Techniques and procedures to protect AI systems from threats and vulnerabilities."
  },
  {
    "key": 16,
    "value": "AI services",
    "description": "Services with pre-trained models that allow developers to embed intelligence into applications without deep ML expertise."
  },
  {
    "key": 17,
    "value": "AI systems",
    "description": "Software applications that incorporate artificial intelligence capabilities."
  },
  {
    "key": 18,
    "value": "AI winter",
    "description": "A period of reduced funding and interest in AI research, often due to unmet expectations. There have been two major AI winters, roughly from 1974 to 1980 and 1987 to 2000, along with several smaller episodes. These were triggered by factors like the failure of machine translation in 1966 and criticism of early neural networks (perceptrons) in 1969."
  },
  {
    "key": 19,
    "value": "Amazon Bedrock",
    "description": "A managed service by AWS that offers foundation models for generative AI applications without requiring infrastructure management."
  },
  {
    "key": 20,
    "value": "Amazon Bedrock Agents",
    "description": "Service for building AI agents that can perform complex tasks."
  },
  {
    "key": 21,
    "value": "Amazon Bedrock Guardrails",
    "description": "Configurable safeguards for implementing responsible AI principles in generative AI applications."
  },
  {
    "key": 22,
    "value": "Amazon CloudWatch",
    "description": "AWS service for monitoring and observability of resources and applications."
  },
  {
    "key": 23,
    "value": "Amazon Comprehend",
    "description": "A fully managed natural language processing service that extracts meaningful insights from unstructured text data."
  },
  {
    "key": 24,
    "value": "Amazon Kendra",
    "description": "Enterprise search service that can be integrated with knowledge bases."
  },
  {
    "key": 25,
    "value": "Amazon Macie",
    "description": "AWS service for discovering and protecting sensitive data."
  },
  {
    "key": 26,
    "value": "Amazon OpenSearch Serverless",
    "description": "Managed search service supporting vector operations."
  },
  {
    "key": 27,
    "value": "Amazon Q",
    "description": "A generative AI assistant designed to enhance productivity for both developers and business users through code assistance and organizational intelligence."
  },
  {
    "key": 28,
    "value": "Amazon S3",
    "description": "See Amazon Simple Storage Service."
  },
  {
    "key": 29,
    "value": "Amazon SageMaker",
    "description": "A comprehensive machine learning platform that combines AWS ML and analytics capabilities into an integrated environment."
  },
  {
    "key": 30,
    "value": "Amazon SageMaker Clarify",
    "description": "Tool for enhancing transparency and fairness in ML models."
  },
  {
    "key": 31,
    "value": "Amazon SageMaker Experiments",
    "description": "Framework for tracking and analyzing ML experiments."
  },
  {
    "key": 32,
    "value": "Amazon SageMaker Jumpstart",
    "description": "Service for facilitating model fine-tuning with proprietary data."
  },
  {
    "key": 33,
    "value": "Amazon SageMaker Model Monitor",
    "description": "Service for continuous oversight of ML models in production."
  },
  {
    "key": 34,
    "value": "Amazon SageMaker Pipelines",
    "description": "Service for streamlining and automating ML workflows."
  },
  {
    "key": 35,
    "value": "Amazon Simple Storage Service (S3)",
    "description": "Object storage service used for storing datasets and model artifacts."
  },
  {
    "key": 36,
    "value": "Amazon Textract",
    "description": "A fully managed machine learning service that automatically extracts text and data from scanned documents and images."
  },
  {
    "key": 37,
    "value": "Amazon Translate",
    "description": "A neural machine translation service that enables real-time translation between languages."
  },
  {
    "key": 38,
    "value": "Anomaly detection",
    "description": "Identifying data points that deviate significantly from the norm, often used in fraud detection."
  },
  {
    "key": 39,
    "value": "Apache Airflow",
    "description": "Open-source platform for programmatically authoring, scheduling, and monitoring workflows using DAGs."
  },
  {
    "key": 40,
    "value": "ApplyGuardrail API",
    "description": "Interface for evaluating and filtering AI-generated content."
  },
  {
    "key": 41,
    "value": "Area Under ROC Curve (AUC)",
    "description": "Metric that assesses a model’s ability to distinguish between classes across various thresholds."
  },
  {
    "key": 42,
    "value": "Artificial intelligence",
    "description": "The theory and development of computer systems able to perform tasks that normally require human intelligence, such as visual perception, speech recognition, decision-making, and translation between languages."
  },
  {
    "key": 43,
    "value": "Asynchronous inference",
    "description": "SageMaker deployment option for handling time-consuming predictions without requiring an immediate response."
  },
  {
    "key": 44,
    "value": "ATLAS framework",
    "description": "MITRE’s knowledge base of adversary tactics and techniques against AI systems."
  },
  {
    "key": 45,
    "value": "Attention mechanism",
    "description": "A technique in neural networks that dynamically focuses on relevant parts of input data."
  },
  {
    "key": 46,
    "value": "Audit mechanisms",
    "description": "Tools and processes for reviewing and verifying compliance with security controls."
  },
  {
    "key": 47,
    "value": "Auto-scaling",
    "description": "Automatic adjustment of computational resources based on workload demands."
  },
  {
    "key": 48,
    "value": "Autoencoders",
    "description": "Neural networks used for unsupervised learning, often for dimensionality reduction or anomaly detection."
  },
  {
    "key": 49,
    "value": "Automated retraining",
    "description": "Process of automatically updating models based on performance triggers."
  },
  {
    "key": 50,
    "value": "Automatic Prompt Optimization",
    "description": "A feature in Amazon Bedrock that helps improve prompt effectiveness automatically."
  },
  {
    "key": 51,
    "value": "Autoregressive architectures",
    "description": "Neural network architectures that generate outputs sequentially, with each new output depending on previously generated outputs."
  },
  {
    "key": 52,
    "value": "Autoregressive modeling",
    "description": "Training approach where models predict next tokens based solely on preceding tokens; commonly used in language models."
  },
  {
    "key": 53,
    "value": "AWS Artifact",
    "description": "Service providing on-demand access to AWS security and compliance documents."
  },
  {
    "key": 54,
    "value": "AWS Audit Manager",
    "description": "Service that streamlines the process of security and compliance audits."
  },
  {
    "key": 55,
    "value": "AWS Cloud Development Kit (CDK)",
    "description": "Framework for defining cloud infrastructure using programming languages like Python or TypeScript."
  },
  {
    "key": 56,
    "value": "AWS CloudFormation",
    "description": "Service for defining and provisioning AWS infrastructure using templates."
  },
  {
    "key": 57,
    "value": "AWS Config",
    "description": "Service for assessing and evaluating resource configurations and compliance."
  },
  {
    "key": 58,
    "value": "AWS Config Rules",
    "description": "Predefined or custom rules for evaluating resource compliance."
  },
  {
    "key": 59,
    "value": "AWS Glue",
    "description": "Managed extract, transform, and load (ETL) service for data cataloging and transformation."
  },
  {
    "key": 60,
    "value": "AWS Key Management Service (KMS)",
    "description": "Service that allows customers to manage their own encryption keys for data protection."
  },
  {
    "key": 61,
    "value": "AWS Local Zones",
    "description": "Fully managed infrastructure deployments that place AWS services close to customers’ data centers for data residency compliance."
  },
  {
    "key": 62,
    "value": "AWS PrivateLink",
    "description": "Service enabling private connectivity between VPCs and AWS services."
  },
  {
    "key": 63,
    "value": "AWS Step Functions",
    "description": "Serverless orchestration service for coordinating multiple AWS services in workflows."
  },
  {
    "key": 64,
    "value": "Backpropagation",
    "description": "An algorithm for training neural networks by propagating errors backward to adjust weights."
  },
  {
    "key": 65,
    "value": "Backward pass",
    "description": "Phase in neural network training where gradients are computed and weights updated based on loss calculations."
  },
  {
    "key": 66,
    "value": "Baseline generation",
    "description": "Process of creating reference points for normal system behavior, usually in the context of benchmarking performance."
  },
  {
    "key": 67,
    "value": "Baseline model",
    "description": "Initial model version used as a reference for comparison."
  },
  {
    "key": 68,
    "value": "Baseline statistics",
    "description": "Reference measurements established during model training used to detect deviations in data quality and model performance over time."
  },
  {
    "key": 69,
    "value": "Batch inference",
    "description": "Processing large volumes of data at once; suitable for periodic predictions."
  },
  {
    "key": 70,
    "value": "Batch processing",
    "description": "Method of handling multiple requests simultaneously for cost efficiency."
  },
  {
    "key": 71,
    "value": "Batch size",
    "description": "Number of training examples processed in one iteration."
  },
  {
    "key": 72,
    "value": "Batch transform",
    "description": "Amazon SageMaker feature for processing large amounts of data in batches without maintaining a persistent endpoint."
  },
  {
    "key": 73,
    "value": "Bedrock Data Automation",
    "description": "Amazon Bedrock feature that simplifies knowledge base setup by automating a data ingestion pipeline."
  },
  {
    "key": 74,
    "value": "Bedrock Knowledge Base",
    "description": "Amazon Bedrock feature for enhancing the accuracy of AI models by grounding responses in trusted information."
  },
  {
    "key": 75,
    "value": "Benchmark datasets",
    "description": "Standard datasets used for comparing model performance."
  },
  {
    "key": 76,
    "value": "BERT",
    "description": "Stands for Bidirectional Encoder Representations from Transformers. A transformerbased model for natural language processing tasks like question answering."
  },
  {
    "key": 77,
    "value": "Bias detection",
    "description": "Process of identifying systematic prejudices in AI systems."
  },
  {
    "key": 78,
    "value": "Bias in AI",
    "description": "Systematic errors in model predictions due to flawed assumptions or biased training data."
  },
  {
    "key": 79,
    "value": "Bidirectional LSTMs",
    "description": "A type of recurrent neural network that processes sequences in both forward and backward directions to capture context."
  },
  {
    "key": 80,
    "value": "Black-box attacks",
    "description": "Attack technique using only API access to refine adversarial inputs."
  },
  {
    "key": 81,
    "value": "Black-box transfer",
    "description": "Attack method using proxy models to generate adversarial inputs."
  },
  {
    "key": 82,
    "value": "Blue/green deployment",
    "description": "A deployment strategy where two identical environments run in parallel during updates, allowing for quick rollback if issues arise."
  },
  {
    "key": 83,
    "value": "Business Associate Addendum (BAA)",
    "description": "Legal agreement between AWS and organizations handling Protected Health Information (PHI)."
  },
  {
    "key": 84,
    "value": "Canary deployment",
    "description": "A deployment method where changes are gradually rolled out to a small subset of users before full deployment."
  },
  {
    "key": 85,
    "value": "Catastrophic forgetting",
    "description": "Issue where models lose previously learned general knowledge during domain-specific training."
  },
  {
    "key": 86,
    "value": "Causal language modeling",
    "description": "Training approach where models predict next tokens based on preceding context."
  },
  {
    "key": 87,
    "value": "Chain prompting",
    "description": "Multi-step approach for gradually manipulating AI system responses."
  },
  {
    "key": 88,
    "value": "Chain-of-responsibility",
    "description": "A pattern in which tasks are broken down into sequential steps with clear handoffs between components."
  },
  {
    "key": 89,
    "value": "Chain-of-thought reasoning",
    "description": "Technique in which models show step-by-step logical progression in problem-solving."
  },
  {
    "key": 90,
    "value": "Chatbots",
    "description": "AI-powered conversational agents that simulate human-like interactions."
  },
  {
    "key": 91,
    "value": "Chunking",
    "description": "Grouping tokens into meaningful phrases to help models understand structural relationships in language."
  },
  {
    "key": 92,
    "value": "CI/CD",
    "description": "See continuous integration/continuous delivery."
  },
  {
    "key": 93,
    "value": "Classification",
    "description": "A supervised learning technique for assigning data points to predefined categories."
  },
  {
    "key": 94,
    "value": "CleverHans",
    "description": "An open-source library for adversarial machine learning research."
  },
  {
    "key": 95,
    "value": "CloudFormation StackSets",
    "description": "Feature for replicating infrastructure across regions."
  },
  {
    "key": 96,
    "value": "CloudWatch",
    "description": "AWS service for monitoring applications and infrastructure."
  },
  {
    "key": 97,
    "value": "Clustering",
    "description": "An unsupervised learning technique for grouping similar data points based on inherent patterns."
  },
  {
    "key": 98,
    "value": "Compliance",
    "description": "Adherence to internal policies, industry standards, and regulatory requirements."
  },
  {
    "key": 99,
    "value": "Computer vision (CV)",
    "description": "A field of AI focused on enabling machines to interpret and analyze visual content."
  },
  {
    "key": 100,
    "value": "Conformance pack",
    "description": "Collection of AWS Config rules and remediation actions packaged together for deploying compliance policies across multiple accounts and regions."
  },
  {
    "key": 101,
    "value": "Confusion matrix",
    "description": "A table summarizing prediction results in classification tasks that counts true and false positives and true and false negatives."
  },
  {
    "key": 102,
    "value": "Constitutional AI",
    "description": "A framework for aligning AI systems with ethical and legal guidelines."
  },
  {
    "key": 103,
    "value": "Consumer applications",
    "description": "AI services available to the general public without integration."
  },
  {
    "key": 104,
    "value": "Container",
    "description": "A standardized unit of software that encapsulates an application and all its dependencies, including code, runtime, system tools, system libraries, and configurations, allowing it to run quickly and reliably across diverse computing environments, from a developer’s local machine to on-premises servers, cloud platforms, or hybrid infrastructures."
  },
  {
    "key": 105,
    "value": "Content filters",
    "description": "Tools that prevent AI from generating harmful or inappropriate content."
  },
  {
    "key": 106,
    "value": "Context dilution",
    "description": "A phenomenon in which critical information becomes less influential as the context length increases in language models."
  },
  {
    "key": 107,
    "value": "Context preparation",
    "description": "Process of organizing retrieved information for model input."
  },
  {
    "key": 108,
    "value": "Context window",
    "description": "Maximum amount of text a model can process in a single interaction."
  },
  {
    "key": 109,
    "value": "Contextual grounding checks",
    "description": "Validation of AI responses against factual data."
  },
  {
    "key": 110,
    "value": "Continuous integration/continuous delivery (CI/CD)",
    "description": "Automated pipeline for software development and deployment."
  },
  {
    "key": 111,
    "value": "Continuous model monitoring",
    "description": "Ongoing assessment of AI model performance and behavior."
  },
  {
    "key": 112,
    "value": "Continuous pre-training",
    "description": "Process of further training an existing model on new domain-specific data to improve performance."
  },
  {
    "key": 113,
    "value": "Convolutional neural networks (CNNs)",
    "description": "Neural networks designed for processing grid-like data, such as images."
  },
  {
    "key": 114,
    "value": "Credit assignment problem",
    "description": "The challenge in reinforcement learning of connecting actions to long-term outcomes."
  },
  {
    "key": 115,
    "value": "Custom terminology",
    "description": "A feature in translation services that allows businesses to maintain consistent terminology across translations."
  },
  {
    "key": 116,
    "value": "Custom vector-based knowledge base",
    "description": "Flexible knowledge base tailored to specific needs."
  },
  {
    "key": 117,
    "value": "Data activity monitoring (DAM)",
    "description": "Techniques for detecting access patterns by usage and frequency to identify potential security threats."
  },
  {
    "key": 118,
    "value": "Data augmentation",
    "description": "Techniques for artificially increasing the variety of training data."
  },
  {
    "key": 119,
    "value": "Data automation",
    "description": "Process of automatically extracting insights from unstructured multimodal content."
  },
  {
    "key": 120,
    "value": "Data classification",
    "description": "Categorization of data based on sensitivity and importance."
  },
  {
    "key": 121,
    "value": "Data deduplication",
    "description": "Process of removing duplicate entries from datasets."
  },
  {
    "key": 122,
    "value": "Data drift",
    "description": "Changes in the statistical properties of model inputs over time that affect model performance."
  },
  {
    "key": 123,
    "value": "Data governance",
    "description": "Policies and practices for managing the quality and security of an organization’s data."
  },
  {
    "key": 124,
    "value": "Data ingestion phase",
    "description": "Initial stage of a retrieval-augmented generation (RAG) workflow involving data collection and processing."
  },
  {
    "key": 125,
    "value": "Data ingestion workflow",
    "description": "Process in Amazon Bedrock for ingesting and processing diverse document types, including text, images, and multimodal documents."
  },
  {
    "key": 126,
    "value": "Data labeling",
    "description": "The process of annotating data with correct outputs for supervised learning."
  },
  {
    "key": 127,
    "value": "Data lineage",
    "description": "Tracking of data movement and transformations through systems."
  },
  {
    "key": 128,
    "value": "Data loss prevention (DLP)",
    "description": "Techniques and tools used to prevent unauthorized data exposure or leakage."
  },
  {
    "key": 129,
    "value": "Data minimization",
    "description": "Principle of collecting and retaining only necessary data."
  },
  {
    "key": 130,
    "value": "Data normalization",
    "description": "Process of standardizing data features to a common scale."
  },
  {
    "key": 131,
    "value": "Data processing",
    "description": "Steps involved in cleaning, transforming, and preparing data for model training."
  },
  {
    "key": 132,
    "value": "Data quality checks",
    "description": "Assessments of the accuracy and completeness of data."
  },
  {
    "key": 133,
    "value": "Data quality monitoring",
    "description": "Continuous assessment of the accuracy and reliability of data."
  },
  {
    "key": 134,
    "value": "Data residency",
    "description": "Physical location where data is stored and processed."
  },
  {
    "key": 135,
    "value": "Data retention",
    "description": "Policies governing how long data should be stored."
  },
  {
    "key": 136,
    "value": "Data sovereignty",
    "description": "Legal authority a nation has over data within its jurisdiction."
  },
  {
    "key": 137,
    "value": "Data validation",
    "description": "Process of verifying the quality and consistency of data."
  },
  {
    "key": 138,
    "value": "Deep learning (DL)",
    "description": "A subset of machine learning that uses multilayered neural networks to learn complex patterns."
  },
  {
    "key": 139,
    "value": "Deep learning revolution",
    "description": "A phase of machine learning research in the 2010s that transformed the capabilities of AI applications."
  },
  {
    "key": 140,
    "value": "Denied topics",
    "description": "Restricted subjects that AI systems should not discuss."
  },
  {
    "key": 141,
    "value": "Deployment pipeline",
    "description": "Automated sequence for moving models to production."
  },
  {
    "key": 142,
    "value": "Diffusion models",
    "description": "Generative models that create data by reversing a noise-adding process, often used for images."
  },
  {
    "key": 143,
    "value": "Directed acyclic graph (DAG)",
    "description": "Representation of a workflow structure consisting of tasks and their dependencies in which nodes are linked by one-way (acyclic) connections."
  },
  {
    "key": 144,
    "value": "Distributed training",
    "description": "Process of training models across multiple computing resources."
  },
  {
    "key": 145,
    "value": "Domain adaptation",
    "description": "Process of adapting pre-trained models to perform well on tasks in specific domains or fields while maintaining general capabilities."
  },
  {
    "key": 146,
    "value": "Dynamic few-shot prompting",
    "description": "A technique that adaptively selects relevant examples for each input query to improve model performance."
  },
  {
    "key": 147,
    "value": "Early stopping",
    "description": "Training optimization technique that halts model training when performance on validation data stops improving."
  },
  {
    "key": 148,
    "value": "Edge deployment",
    "description": "Running AI models directly on end-user devices rather than in the cloud."
  },
  {
    "key": 149,
    "value": "Elastic Fabric Adapter (EFA)",
    "description": "AWS network interface for high-performance computing."
  },
  {
    "key": 150,
    "value": "Electronic protected health information (ePHI)",
    "description": "Digital health data protected under HIPAA."
  },
  {
    "key": 151,
    "value": "Embeddings",
    "description": "Numerical representations of tokens that capture semantic meaning in highdimensional space."
  },
  {
    "key": 152,
    "value": "Ensemble methods",
    "description": "Combining multiple models to improve overall performance and reduce overfitting."
  },
  {
    "key": 153,
    "value": "Enterprise applications",
    "description": "Business-level solutions incorporating AI capabilities."
  },
  {
    "key": 154,
    "value": "European Sovereign Cloud",
    "description": "AWS infrastructure designed for European data sovereignty requirements."
  },
  {
    "key": 155,
    "value": "Evaluation job",
    "description": "A structured process in Amazon Bedrock where models process prompts from selected datasets to assess performance against specific metrics."
  },
  {
    "key": 156,
    "value": "Evaluation metrics",
    "description": "Measurements used to assess AI model performance."
  },
  {
    "key": 157,
    "value": "Expert parallelism",
    "description": "Technique using specialized sub-networks for different inputs."
  },
  {
    "key": 158,
    "value": "F1 score",
    "description": "Metric combining precision and recall for evaluating model performance."
  },
  {
    "key": 159,
    "value": "Fake completion attacks",
    "description": "Attempts to influence AI outputs through pre-completed answers."
  },
  {
    "key": 160,
    "value": "Feature attribution",
    "description": "Methods explaining how input features influence model outputs."
  },
  {
    "key": 161,
    "value": "Feature engineering",
    "description": "The process of selecting and transforming variables in raw data to generate meaningful features for models."
  },
  {
    "key": 162,
    "value": "Feature store",
    "description": "Centralized repository for storing and managing machine learning features."
  },
  {
    "key": 163,
    "value": "Few-shot learning",
    "description": "A technique in which models learn from a small number of examples provided in the prompt."
  },
  {
    "key": 164,
    "value": "Fine-tuned models",
    "description": "AI models customized with organization-specific data."
  },
  {
    "key": 165,
    "value": "Fine-tuning",
    "description": "Process of adapting a pre-trained model for specific tasks or domains."
  },
  {
    "key": 166,
    "value": "Flash attention",
    "description": "Optimization technique for accelerating attention mechanisms in transformer models."
  },
  {
    "key": 167,
    "value": "Format",
    "description": "In the context of machine learning (ML), a standardized structure and encoding used to store and represent various components essential to the ML lifecycle, such as datasets, trained models, and intermediate data structures."
  },
  {
    "key": 168,
    "value": "Forward pass",
    "description": "Initial phase of model computation in which input data flows through a network to generate predictions."
  },
  {
    "key": 169,
    "value": "Foundation models",
    "description": "Pre-trained AI models that can be adapted for various tasks without extensive retraining."
  },
  {
    "key": 170,
    "value": "Fraud detection",
    "description": "Identifying deceptive or anomalous activities, often using supervised or unsupervised learning."
  },
  {
    "key": 171,
    "value": "GDPR",
    "description": "Stands for General Data Protection Regulation, a European Union regulation for data protection and privacy."
  },
  {
    "key": 172,
    "value": "Generative Adversarial Network (GAN)",
    "description": "Neural network in which a generator and discriminator compete to create realistic data."
  },
  {
    "key": 173,
    "value": "Generative AI",
    "description": "AI systems capable of creating new content based on training data."
  },
  {
    "key": 174,
    "value": "Generative AI Security",
    "description": "Specific security measures for AI systems that generate content."
  },
  {
    "key": 175,
    "value": "Generative AI Security Scoping Matrix",
    "description": "Framework defining security requirements across different AI deployment models."
  },
  {
    "key": 176,
    "value": "GitHub Actions",
    "description": "CI/CD tool integrated with GitHub repositories for automation."
  },
  {
    "key": 177,
    "value": "GPU memory optimization",
    "description": "Techniques for efficient use of graphics processing resources."
  },
  {
    "key": 178,
    "value": "Gradient accumulation",
    "description": "Technique for handling large batch sizes with limited memory."
  },
  {
    "key": 179,
    "value": "Gradient boosting",
    "description": "An ensemble learning technique that builds models sequentially to correct errors from previous models."
  },
  {
    "key": 180,
    "value": "Gradient checkpointing",
    "description": "Memory optimization technique that saves only selected activations during forward passes and recomputes others as needed."
  },
  {
    "key": 181,
    "value": "Gradient descent",
    "description": "An optimization algorithm for minimizing loss by iteratively adjusting model parameters."
  },
  {
    "key": 182,
    "value": "Ground truth",
    "description": "Amazon SageMaker feature that enables human-in-the-loop workflows for creating labeled datasets."
  },
  {
    "key": 183,
    "value": "Guardrails",
    "description": "Security and safety features in AI systems that help control outputs and prevent harmful content."
  },
  {
    "key": 184,
    "value": "Hallucinations in AI",
    "description": "Plausible but factually incorrect outputs generated by AI models."
  },
  {
    "key": 185,
    "value": "HIPAA",
    "description": "The Health Insurance Portability and Accountability Act of 1996, a U.S. law protecting the privacy of health information."
  },
  {
    "key": 186,
    "value": "HIPAA Breach Notification Rule",
    "description": "Requirements for reporting unauthorized protected health information (PHI) disclosures."
  },
  {
    "key": 187,
    "value": "HIPAA Privacy Rule",
    "description": "Regulations governing use and disclosure of protected health information (PHI)."
  },
  {
    "key": 188,
    "value": "HIPAA Security Rule",
    "description": "Requirements for safeguarding electronic protected health information (ePHI)."
  },
  {
    "key": 189,
    "value": "Hopfield network",
    "description": "A type of recurrent neural network used for associative memory tasks."
  },
  {
    "key": 190,
    "value": "Hugging Face Transformers",
    "description": "Library for working with transformer-based models."
  },
  {
    "key": 191,
    "value": "Human evaluation",
    "description": "Assessment of model outputs by human reviewers for quality and appropriateness."
  },
  {
    "key": 192,
    "value": "Human-centered AI",
    "description": "Design approach prioritizing human needs and oversight in AI systems."
  },
  {
    "key": 193,
    "value": "Human-in-the-loop",
    "description": "A process that combines automated AI systems with human oversight and intervention."
  },
  {
    "key": 194,
    "value": "Hyperparameter optimization",
    "description": "Process of finding optimal model configuration settings; also called hyperparameter tuning."
  },
  {
    "key": 195,
    "value": "Hyperparameters",
    "description": "Configuration settings that control the learning process of a model."
  },
  {
    "key": 196,
    "value": "IAM roles",
    "description": "AWS identity management for resource access control."
  },
  {
    "key": 197,
    "value": "Image classification",
    "description": "Assigning predefined labels to images based on their content."
  },
  {
    "key": 198,
    "value": "Image segmentation",
    "description": "Partitioning an image into segments for detailed analysis, often used in medical imaging."
  },
  {
    "key": 199,
    "value": "Inertia",
    "description": "A metric used to evaluate clustering performance by measuring the compactness of clusters."
  },
  {
    "key": 200,
    "value": "Inference",
    "description": "The process of using a trained model to make predictions on new data."
  },
  {
    "key": 201,
    "value": "Inference components",
    "description": "Amazon SageMaker features for optimizing model serving."
  },
  {
    "key": 202,
    "value": "Inference optimization",
    "description": "Techniques for improving model serving efficiency."
  },
  {
    "key": 203,
    "value": "Inference parameters",
    "description": "Settings that control how AI models generate responses, including temperature and sampling methods."
  },
  {
    "key": 204,
    "value": "Infrastructure as Code (IaC)",
    "description": "Practice of managing infrastructure through versioncontrolled scripts."
  },
  {
    "key": 205,
    "value": "Input optimization",
    "description": "Technique to minimize token usage while maintaining output quality."
  },
  {
    "key": 206,
    "value": "Input validation",
    "description": "Process of verifying and sanitizing data inputs."
  },
  {
    "key": 207,
    "value": "Instruction tuning",
    "description": "Fine-tuning approach that uses explicit task instructions and examples to guide model behavior."
  },
  {
    "key": 208,
    "value": "ISO/IEC JTC 1/SC 42",
    "description": "International technical standards committee for AI standardization."
  },
  {
    "key": 209,
    "value": "Jailbreaking",
    "description": "Attempts to circumvent model safety measures and ethical guidelines."
  },
  {
    "key": 210,
    "value": "Jenkins",
    "description": "Open-source automation server for building, testing, and deploying code."
  },
  {
    "key": 211,
    "value": "Jenkins file",
    "description": "Script defining CI/CD pipeline steps."
  },
  {
    "key": 212,
    "value": "JumpStart",
    "description": "A comprehensive machine learning hub in SageMaker that provides access to pre-built models and solutions."
  },
  {
    "key": 213,
    "value": "Knowledge bases",
    "description": "A feature in Amazon Bedrock that enhances foundation models with proprietary information using RAG."
  },
  {
    "key": 214,
    "value": "Knowledge distillation",
    "description": "Process of transferring knowledge from a large model to a smaller one."
  },
  {
    "key": 215,
    "value": "Labeled data",
    "description": "Data annotated with correct outputs, used for supervised learning."
  },
  {
    "key": 216,
    "value": "Lambda functions",
    "description": "Serverless computing service for running code."
  },
  {
    "key": 217,
    "value": "Large language model (LLM)",
    "description": "Transformer -based generative AI model trained on vast amounts of text data for language tasks."
  },
  {
    "key": 218,
    "value": "Latent space",
    "description": "A compressed representation of data learned by models like VAEs or autoencoders."
  },
  {
    "key": 219,
    "value": "Learning rate",
    "description": "A hyperparameter controlling how much model weights are updated during training."
  },
  {
    "key": 220,
    "value": "LLM-as-a-judge",
    "description": "A feature that uses LLMs to autonomously evaluate and score responses generated by other models, providing metrics like correctness, completeness, and faithfulness."
  },
  {
    "key": 221,
    "value": "Load balancing",
    "description": "Distribution of workloads across computing resources."
  },
  {
    "key": 222,
    "value": "Logistic regression",
    "description": "A classification algorithm predicting the probability of a binary outcome."
  },
  {
    "key": 223,
    "value": "Long Short-Term Memory (LSTM)",
    "description": "A type of RNN designed to capture long-range dependencies in sequential data."
  },
  {
    "key": 224,
    "value": "LoRA",
    "description": "Stands for Low-Rank Adaptation, a technique for efficient model fine-tuning."
  },
  {
    "key": 225,
    "value": "Machine learning (ML)",
    "description": "A subset of AI focused on algorithms that learn patterns from data."
  },
  {
    "key": 226,
    "value": "Masked language modeling",
    "description": "Training approach where models predict masked tokens using bidirectional context."
  },
  {
    "key": 227,
    "value": "Maximum output length",
    "description": "A parameter that controls how many tokens a model can generate in a single response."
  },
  {
    "key": 228,
    "value": "Mean Squared Error (MSE)",
    "description": "A regression metric measuring the average squared difference between predicted and actual values."
  },
  {
    "key": 229,
    "value": "Metadata filters",
    "description": "Controls for filtering data based on associated information."
  },
  {
    "key": 230,
    "value": "Minimum necessary standard",
    "description": "HIPAA requirement to limit access to protected health information (PHI) only for essential needs."
  },
  {
    "key": 231,
    "value": "Mixed-precision training",
    "description": "Training technique using different numerical precisions (like FP16 and FP32) to optimize memory usage and computation speed."
  },
  {
    "key": 232,
    "value": "ML",
    "description": "See machine learning."
  },
  {
    "key": 233,
    "value": "MLFlow",
    "description": "Platform for managing the machine learning lifecycle."
  },
  {
    "key": 234,
    "value": "MLOps",
    "description": "Practices and tools for managing, automating, and scaling machine learning workflows."
  },
  {
    "key": 235,
    "value": "Model artifacts",
    "description": "Files containing trained model parameters and configurations needed for deployment."
  },
  {
    "key": 236,
    "value": "Model card",
    "description": "Standardized documentation that provides detailed information about AI models’ capabilities and limitations."
  },
  {
    "key": 237,
    "value": "Model compression",
    "description": "Techniques for reducing model size while maintaining performance."
  },
  {
    "key": 238,
    "value": "Model customization",
    "description": "Techniques like fine-tuning and continued pre-training to adapt models for specific use cases."
  },
  {
    "key": 239,
    "value": "Model distillation",
    "description": "Technique to compress knowledge from larger models into smaller, more efficient versions."
  },
  {
    "key": 240,
    "value": "Model drift",
    "description": "Degradation in model performance over time."
  },
  {
    "key": 241,
    "value": "Model evaluation",
    "description": "Process of assessing model performance and behavior."
  },
  {
    "key": 242,
    "value": "Model governance",
    "description": "Framework for managing ML model lifecycle and compliance."
  },
  {
    "key": 243,
    "value": "Model monitor",
    "description": "SageMaker feature for tracking production model performance."
  },
  {
    "key": 244,
    "value": "Model monitoring",
    "description": "Continuous observation of model performance and behavior."
  },
  {
    "key": 245,
    "value": "Model package groups",
    "description": "Collections in the Model Registry that organize related model versions and their associated metadata."
  },
  {
    "key": 246,
    "value": "Model package versions",
    "description": "Individual iterations of models within a model package group, tracking changes and updates over time."
  },
  {
    "key": 247,
    "value": "Model quality checks",
    "description": "Assessments of model accuracy and reliability."
  },
  {
    "key": 248,
    "value": "Model registry",
    "description": "A centralized system for versioning and tracking ML models and their metadata."
  },
  {
    "key": 249,
    "value": "Multi-agent collaboration",
    "description": "Coordination of multiple specialized AI agents working together to accomplish complex tasks."
  },
  {
    "key": 250,
    "value": "Multimodal data",
    "description": "Data combining different types of information (e.g., text, images, and audio)."
  },
  {
    "key": 251,
    "value": "Multimodal models",
    "description": "AI systems capable of processing multiple data types (e.g., text, images, and audio)."
  },
  {
    "key": 252,
    "value": "Multimodal processing",
    "description": "Handling different types of data inputs simultaneously."
  },
  {
    "key": 253,
    "value": "Natural language processing (NLP)",
    "description": "A field of AI focused on enabling machines to understand and generate human language."
  },
  {
    "key": 254,
    "value": "Neural network weights",
    "description": "Adjustable parameters learned during model training that determine network behavior."
  },
  {
    "key": 255,
    "value": "Neural networks",
    "description": "Computational models inspired by biological neurons, used for learning complex patterns."
  },
  {
    "key": 256,
    "value": "Nucleus sampling",
    "description": "Also known as Top-P sampling, an adaptive approach for token selection based on cumulative probability."
  },
  {
    "key": 257,
    "value": "NVLink",
    "description": "NVIDIA’s high-speed GPU interconnect technology."
  },
  {
    "key": 258,
    "value": "Object detection",
    "description": "Identifying and locating objects within images or videos."
  },
  {
    "key": 259,
    "value": "Optical character recognition (OCR)",
    "description": "Technology for extracting text from images."
  },
  {
    "key": 260,
    "value": "Online inference",
    "description": "Real-time processing of individual requests as they arrive."
  },
  {
    "key": 261,
    "value": "Orchestration",
    "description": "Coordination and automation of multiple processes or services."
  },
  {
    "key": 262,
    "value": "Overfitting",
    "description": "When a model learns noise or overly specific patterns in training data, harming its ability to generalize."
  },
  {
    "key": 263,
    "value": "Paged attention",
    "description": "Technique for processing long sequences in smaller chunks."
  },
  {
    "key": 264,
    "value": "Parameter count",
    "description": "Number of trainable variables in a neural network."
  },
  {
    "key": 265,
    "value": "Parameter efficient fine-tuning",
    "description": "Methods to adapt models by updating minimal parameters."
  },
  {
    "key": 266,
    "value": "PartyRock",
    "description": "An interactive platform for creating and sharing generative AI applications without coding expertise."
  },
  {
    "key": 267,
    "value": "Perplexity",
    "description": "Metric for evaluating language model performance."
  },
  {
    "key": 268,
    "value": "Persona switches",
    "description": "Attack technique making AI adopt different personalities."
  },
  {
    "key": 269,
    "value": "Physical safeguards",
    "description": "Physical measures to protect systems and data."
  },
  {
    "key": 270,
    "value": "Pipeline orchestration",
    "description": "Coordinating and automating the flow of data through ML system components."
  },
  {
    "key": 271,
    "value": "Post-processing",
    "description": "Final stage of refining model outputs."
  },
  {
    "key": 272,
    "value": "Pre-trained models",
    "description": "Existing models available through platforms like Amazon Bedrock."
  },
  {
    "key": 273,
    "value": "Pre-training",
    "description": "Initial training of models on large datasets to learn general patterns."
  },
  {
    "key": 274,
    "value": "Predictive analytics",
    "description": "Using historical data to forecast future outcomes or trends."
  },
  {
    "key": 275,
    "value": "Preprocessing prompt",
    "description": "Initial processing step to validate and contextualize input."
  },
  {
    "key": 276,
    "value": "Production deployment",
    "description": "The process of moving approved models into live environments for real-world use after passing necessary quality and governance checks."
  },
  {
    "key": 277,
    "value": "Production variants",
    "description": "Different versions of deployed models."
  },
  {
    "key": 278,
    "value": "Prompt engineering",
    "description": "The practice of crafting effective inputs to AI models to achieve desired outputs."
  },
  {
    "key": 279,
    "value": "Prompt injection",
    "description": "Attack technique in which malicious commands are embedded within normal text inputs to an AI system."
  },
  {
    "key": 280,
    "value": "Prompt leakage",
    "description": "A security vulnerability in which carefully crafted prompts can be reconstructed through systematic querying."
  },
  {
    "key": 281,
    "value": "Prompt poisoning",
    "description": "Attack method involving deliberate training on malicious prompts."
  },
  {
    "key": 282,
    "value": "Pruning",
    "description": "Technique of removing less important parameters from models."
  },
  {
    "key": 283,
    "value": "QLoRA",
    "description": "Quantized version of LoRA for more efficient fine-tuning."
  },
  {
    "key": 284,
    "value": "Quality gates",
    "description": "Checkpoints ensuring quality standards are met."
  },
  {
    "key": 285,
    "value": "Quantization",
    "description": "Technique of reducing numerical precision to optimize model size."
  },
  {
    "key": 286,
    "value": "RAG",
    "description": "See retrieval-augmented generation."
  },
  {
    "key": 287,
    "value": "RAG evaluation",
    "description": "Assessment of retrieval-augmented generation systems."
  },
  {
    "key": 288,
    "value": "Random forest",
    "description": "An ensemble learning method using multiple decision trees for classification or regression."
  },
  {
    "key": 289,
    "value": "Real-time AI supervision",
    "description": "Dynamic monitoring of AI system behavior."
  },
  {
    "key": 290,
    "value": "Real-time endpoints",
    "description": "SageMaker deployment option for immediate model predictions."
  },
  {
    "key": 291,
    "value": "Real-time inference",
    "description": "Generating predictions instantly in response to user requests."
  },
  {
    "key": 292,
    "value": "Reconnaissance (AI security context)",
    "description": "Activities where adversaries gather information about AI systems to plan attacks, including collecting details on ML capabilities, research publications, and system configurations."
  },
  {
    "key": 293,
    "value": "Recurrent neural network (RNN)",
    "description": "Neural network designed for sequential data, with memory of past inputs."
  },
  {
    "key": 294,
    "value": "Red teaming",
    "description": "A practice of systematically testing AI models for vulnerabilities and potential misuse cases."
  },
  {
    "key": 295,
    "value": "Regression",
    "description": "A supervised learning technique for predicting continuous numerical values."
  },
  {
    "key": 296,
    "value": "Reinforcement learning",
    "description": "A learning paradigm in which agents learn by interacting with an environment and receiving rewards."
  },
  {
    "key": 297,
    "value": "Reranking",
    "description": "Process of improving search result relevance."
  },
  {
    "key": 298,
    "value": "Resource optimization",
    "description": "Efficient allocation and use of computing resources."
  },
  {
    "key": 299,
    "value": "Response quality",
    "description": "A metric that assesses the coherence, relevance, and usefulness of AI-generated outputs."
  },
  {
    "key": 300,
    "value": "Responsible AI",
    "description": "Practice of developing AI systems ethically and safely."
  },
  {
    "key": 301,
    "value": "Retrieval-augmented generation (RAG)",
    "description": "A technique that enhances language models with external knowledge sources."
  },
  {
    "key": 302,
    "value": "Right to erasure",
    "description": "GDPR provision allowing individuals to request deletion of their personal data."
  },
  {
    "key": 303,
    "value": "Risk assessment",
    "description": "Process of identifying and evaluating potential threats."
  },
  {
    "key": 304,
    "value": "Role playing",
    "description": "A prompt engineering technique in which a model is instructed to adopt a specific persona or area of expertise."
  },
  {
    "key": 305,
    "value": "Rolling deployment",
    "description": "A deployment strategy in which updates are incrementally implemented across instances while maintaining service availability."
  },
  {
    "key": 306,
    "value": "ROUGE score",
    "description": "Metric for evaluating the quality of generated text by comparing it with reference texts."
  },
  {
    "key": 307,
    "value": "SageMaker Canvas",
    "description": "A no-code tool for building and deploying machine learning models."
  },
  {
    "key": 308,
    "value": "SageMaker Clarify",
    "description": "A tool for detecting and mitigating bias in AI models."
  },
  {
    "key": 309,
    "value": "SageMaker Feature Store",
    "description": "A centralized repository for storing and managing machine learning features."
  },
  {
    "key": 310,
    "value": "SageMaker HyperPod",
    "description": "Persistent clusters for advanced model training."
  },
  {
    "key": 311,
    "value": "SageMaker Inference",
    "description": "Suite of deployment options for serving models in production."
  },
  {
    "key": 312,
    "value": "SageMaker Model Monitor",
    "description": "AWS service that continuously monitors deployed models for data/concept drift and quality issues."
  },
  {
    "key": 313,
    "value": "SageMaker Pipelines",
    "description": "Service for building and managing ML workflows."
  },
  {
    "key": 314,
    "value": "SageMaker Processing Jobs",
    "description": "Managed service for running data processing, feature engineering, and model evaluation workloads."
  },
  {
    "key": 315,
    "value": "SageMaker Studio",
    "description": "An integrated development environment specifically built for machine learning."
  },
  {
    "key": 316,
    "value": "SageMaker Training Jobs",
    "description": "Managed environment for distributed model training."
  },
  {
    "key": 317,
    "value": "Scaling policies",
    "description": "Rules determining how resources should scale with demand."
  },
  {
    "key": 318,
    "value": "Security controls",
    "description": "Measures implemented to protect systems and data."
  },
  {
    "key": 319,
    "value": "Security groups",
    "description": "AWS network security controls."
  },
  {
    "key": 320,
    "value": "Self-attention",
    "description": "A mechanism in transformers allowing a model to dynamically focus on relevant tokens in the input data."
  },
  {
    "key": 321,
    "value": "Self-supervised learning",
    "description": "Training approach where models learn from unlabeled data by generating their own supervision signals."
  },
  {
    "key": 322,
    "value": "Semantic chunking",
    "description": "Content division based on meaning, as opposed to division based on length of chunks."
  },
  {
    "key": 323,
    "value": "Sensitive information filters",
    "description": "Tools for detecting and redacting personal identifiable information."
  },
  {
    "key": 324,
    "value": "Serverless inference",
    "description": "SageMaker deployment option for automatic resource management."
  },
  {
    "key": 325,
    "value": "SGLang",
    "description": "A serving framework for optimizing LLM inference."
  },
  {
    "key": 326,
    "value": "Shadow testing",
    "description": "Testing technique where new versions receive copied production traffic."
  },
  {
    "key": 327,
    "value": "Shared responsibility model",
    "description": "Division of security duties between AWS and customers."
  },
  {
    "key": 328,
    "value": "Silhouette score",
    "description": "A clustering metric measuring how similar a data point is to its own cluster compared to others."
  },
  {
    "key": 329,
    "value": "Similarity search",
    "description": "Process of finding related content using vector comparisons."
  },
  {
    "key": 330,
    "value": "Slurm",
    "description": "Job scheduler and cluster management system used for distributed computing workloads."
  },
  {
    "key": 331,
    "value": "Speculative decoding",
    "description": "Technique for accelerating text generation using smaller helper models."
  },
  {
    "key": 332,
    "value": "Stop sequences",
    "description": "Special parameters that control where model generation should end."
  },
  {
    "key": 333,
    "value": "Structured data",
    "description": "Highly organized data, usually in tabular form with predefined fields."
  },
  {
    "key": 334,
    "value": "Structured data knowledge base",
    "description": "Knowledge base integrated with organized data sources."
  },
  {
    "key": 335,
    "value": "Supervised learning",
    "description": "Training models on labeled data to predict outputs for new inputs."
  },
  {
    "key": 336,
    "value": "Support vector machine (SVM)",
    "description": "A classification algorithm for finding the optimal boundary between classes."
  },
  {
    "key": 337,
    "value": "Technical debt",
    "description": "Accumulated complexity from shortcuts in development."
  },
  {
    "key": 338,
    "value": "Technical safeguards",
    "description": "Technology-based measures to protect data."
  },
  {
    "key": 339,
    "value": "Temperature",
    "description": "A parameter that controls randomness and creativity in model outputs."
  },
  {
    "key": 340,
    "value": "Tensor parallelism",
    "description": "Technique for distributing model computations across devices."
  },
  {
    "key": 341,
    "value": "Terraform",
    "description": "Infrastructure as Code (IaC) tool for cloud resource management."
  },
  {
    "key": 342,
    "value": "Time to First Token (TTFT)",
    "description": "The time taken for a model to generate its first response token."
  },
  {
    "key": 343,
    "value": "Time to Last Token (TTLT)",
    "description": "The total time taken for a model to complete its entire response."
  },
  {
    "key": 344,
    "value": "Token",
    "description": "Basic unit of text processing in language models."
  },
  {
    "key": 345,
    "value": "Tokenization",
    "description": "Breaking text into smaller units (tokens) for processing by AI models."
  },
  {
    "key": 346,
    "value": "Top-K sampling",
    "description": "A parameter that limits token selection to the k most likely options."
  },
  {
    "key": 347,
    "value": "Top-P sampling",
    "description": "Probability-based method for controlling token selection."
  },
  {
    "key": 348,
    "value": "Toxicity metrics",
    "description": "Measurements of harmful content in AI outputs."
  },
  {
    "key": 349,
    "value": "Training artifacts",
    "description": "Files and metadata generated during model training, typically the trained model files."
  },
  {
    "key": 350,
    "value": "Training loop",
    "description": "Iterative process of model training and optimization."
  },
  {
    "key": 351,
    "value": "Training metrics",
    "description": "Measurements of model performance during training."
  },
  {
    "key": 352,
    "value": "Transfer learning",
    "description": "Using knowledge learned in one task to improve performance on a different but related task."
  },
  {
    "key": 353,
    "value": "Transformer",
    "description": "Neural network architecture using self-attention for parallel processing of sequential data."
  },
  {
    "key": 354,
    "value": "Transparency",
    "description": "Clarity in how AI systems make decisions."
  },
  {
    "key": 355,
    "value": "Trial",
    "description": "Individual iteration of an ML experiment in SageMaker Experiments."
  },
  {
    "key": 356,
    "value": "Triton server",
    "description": "NVIDIA’s inference serving software that enables efficient multimodel serving on GPUs."
  },
  {
    "key": 357,
    "value": "Underfitting",
    "description": "When a model is too simple to capture underlying patterns in the data."
  },
  {
    "key": 358,
    "value": "Unlabeled data",
    "description": "Data without annotations, used in unsupervised or self-supervised learning."
  },
  {
    "key": 359,
    "value": "Unstructured data",
    "description": "Data without a predefined format, such as text, images, or audio."
  },
  {
    "key": 360,
    "value": "User input processing",
    "description": "Evaluation of user prompts before AI processing."
  },
  {
    "key": 361,
    "value": "Validation dataset",
    "description": "Data used to evaluate model performance during training."
  },
  {
    "key": 362,
    "value": "Variational autoencoder (VAE)",
    "description": "Generative models that learn compact representations of data for reconstruction or generation."
  },
  {
    "key": 363,
    "value": "Vector database",
    "description": "Storage solution optimized for managing and querying high-dimensional vector data; can also be called a vector store."
  },
  {
    "key": 364,
    "value": "Version control",
    "description": "System for tracking changes in code and configurations."
  },
  {
    "key": 365,
    "value": "Vision transformer (ViT)",
    "description": "Transformer-based model adapted for processing visual data like images."
  },
  {
    "key": 366,
    "value": "vLLM",
    "description": "An open-source library for LLM inference optimization and serving."
  },
  {
    "key": 367,
    "value": "Web crawler",
    "description": "Tool for automatically collecting web content."
  },
  {
    "key": 368,
    "value": "White-box optimization",
    "description": "Attack technique using full access to model internals."
  },
  {
    "key": 369,
    "value": "Word embedding",
    "description": "Numerical representation of words capturing semantic relationships (e.g., Word2Vec)."
  },
  {
    "key": 370,
    "value": "Word filter",
    "description": "Tool for blocking specific words or phrases in AI interactions."
  },
  {
    "key": 371,
    "value": "Zero redundancy optimizer (ZeRO)",
    "description": "Optimization technique that reduces memory usage by distributing model states across GPUs."
  },
  {
    "key": 372,
    "value": "Zero-shot learning",
    "description": "The ability of models to perform tasks without specific examples in the prompt."
  }
];
